import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const countVariants = cva("h-count", {
  variants: {
    variant: {
      primary: "h-count--primary",
      bordered: "h-count--bordered",
    },
  },
})

export interface CountProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof countVariants> {
  number?: string | number
}

const Count = React.forwardRef<HTMLSpanElement, CountProps>(({ className, variant, number, ...props }, ref) => {
  return (
    <span className={cn(countVariants({ variant, className }))} ref={ref} {...props}>
      {number}
    </span>
  )
})
Count.displayName = "Count"

export { Count, countVariants }
